import { Outlet } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";

const GroupMentoringDashboard = () => {
  return (
    <Sidebar>
      <Outlet />
    </Sidebar>
  );
};
export default GroupMentoringDashboard;
